export default function Logo({ className = "", size = "default" }) {
  const sizes = {
    small: { width: 120, height: 40, fontSize: 14, subSize: 7, gap: 2 },
    default: { width: 180, height: 52, fontSize: 20, subSize: 9, gap: 3 },
    large: { width: 240, height: 68, fontSize: 26, subSize: 11, gap: 4 },
  };
  const s = sizes[size] || sizes.default;

  return (
    <svg
      viewBox={`0 0 ${s.width} ${s.height}`}
      width={s.width}
      height={s.height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="gold-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#c5a346" />
          <stop offset="50%" stopColor="#d4b85a" />
          <stop offset="100%" stopColor="#b8933a" />
        </linearGradient>
      </defs>

      {/* Decorative line top */}
      <line x1={s.width * 0.2} y1={4} x2={s.width * 0.8} y2={4} stroke="url(#gold-grad)" strokeWidth="1.5" />

      {/* LITTLE ITALY text */}
      <text
        x={s.width / 2}
        y={s.height * 0.48}
        textAnchor="middle"
        fontFamily="'Playfair Display', 'Gloock', Georgia, serif"
        fontSize={s.fontSize}
        fontWeight="600"
        letterSpacing="1"
        fill="currentColor"
      >
        Little Italy
      </text>

      {/* RISTORANTE subtitle */}
      <text
        x={s.width / 2}
        y={s.height * 0.48 + s.fontSize * 0.7}
        textAnchor="middle"
        fontFamily="'Manrope', 'Inter', system-ui, sans-serif"
        fontSize={s.subSize}
        fontWeight="500"
        letterSpacing="3"
        fill="url(#gold-grad)"
        textDecoration="none"
      >
        RISTORANTE
      </text>

      {/* Decorative line bottom */}
      <line x1={s.width * 0.2} y1={s.height - 4} x2={s.width * 0.8} y2={s.height - 4} stroke="url(#gold-grad)" strokeWidth="1.5" />
    </svg>
  );
}
